:root {
  --g-top-bar-height: 48px;
  --g-mobile-top: 59px;
  --g-mobile-bottom: 94px;
  --g-mobile-preview-max-height: 512px; }

._lassoWrapper_1v93w_7 {
  position: absolute;
  left: calc(-1 * var(--stage-left-margin));
  top: 0;
  width: calc( var(--stage-fixed-width) + var(--stage-left-margin) + var(--stage-right-margin));
  height: 100%; }
  ._lassoWrapper_1v93w_7 ._lassoLayer_1v93w_13 {
    top: 0;
    left: 0;
    width: calc(100% + var(--stage-left-margin)); }

._lassoLayer_1v93w_13 {
  width: 100%;
  height: 100%;
  position: absolute; }
  ._lassoLayer_1v93w_13 ._lassoHighlights_1v93w_22 {
    width: 100%;
    height: 100%;
    shape-rendering: crispEdges; }
    ._lassoLayer_1v93w_13 ._lassoHighlights_1v93w_22 ._lassoRect_1v93w_26 {
      fill: #116dff;
      fill-opacity: 0.24;
      stroke: #116dff;
      stroke-width: 1px; }
    ._lassoLayer_1v93w_13 ._lassoHighlights_1v93w_22 ._lassoCandidate_1v93w_31 {
      stroke: #4a86e8;
      fill: none; }
      ._lassoLayer_1v93w_13 ._lassoHighlights_1v93w_22 ._lassoCandidate_1v93w_31._showOnAllPages_1v93w_34 {
        stroke: #dc9024; }
